'use client';

import { ClientOnlyLoader } from '../../shared/ClientOnlyLoader';
import { Button } from '@/components/ui/button';

const categoriesSelectLoader = () => import('./CategoriesSelectInternal');

const CategoriesSelectFallback = () => (
  <Button
    variant='outline'
    className='border-primary-green-day bg-bg-day h-[44px] min-w-[140px] gap-[8px] rtl:flex-row-reverse active:scale-100'
  >
    <span className='h-[24px] w-[24px] inline-flex items-center justify-center rounded-[6px] bg-gray-100 text-[12px] text-primary-text-day'>
      ☰
    </span>
    <span className='text-[12px] lg:text-m text-primary-text-day whitespace-nowrap'>Categories</span>
  </Button>
);

export function CategoriesSelect() {
  return <ClientOnlyLoader load={categoriesSelectLoader} fallback={<CategoriesSelectFallback />} />;
}

export { CategoriesSelectFallback };
